/*
 * MDB shim for MDBNavLink
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueView.jsx
 * - src/Seating/Reports/dailyOrderCounts.jsx
 * - src/Seating/Tasks/Tasks.jsx
 */

import MUITab from "@mui/material/Tab";

export default function MDBNavLink({ children, active, onClick, href, ...rest }) {
    return (
        <MUITab
            
            label={children}
            onClick={onClick}
            sx={{
                backgroundColor: active ? '#3b6aa0 !important' : undefined,
            }}
            {...rest}
        />
    );
}
